import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/abstract-product";

export const pagingAbstractProductService = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getAbstractProductServiceById = (serviceAbstractProductService) => axios.get(API_PATH + "/get-by-id/" + serviceAbstractProductService);

export const saveOrUpdateAbstractProductService = serviceAbstractProductService => axios.post(API_PATH + "/save-or-update", serviceAbstractProductService);

export const deleteAbstractProductService = serviceAbstractProductService => axios.delete(API_PATH + '/mark-delete/' + serviceAbstractProductService);

export const synchronizeAbstractProductService = (searchObject) => axios.post(API_PATH + "/sync-abstract-product-from-category-store", searchObject);

export const saveIsUsingAbstractProduct = (obj) => axios.post(API_PATH + "/update-is-using", obj);